<template>
    <div class="about">
        <Inbanner />
        <div class="container">
            <el-breadcrumb separator="/" style="margin:20px 0;">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>新闻</el-breadcrumb-item>
                <el-breadcrumb-item>{{newstitle}}</el-breadcrumb-item>
            </el-breadcrumb>
            <el-card class="box-card">
                <div slot="header" class="clearfix">
                    <h3 class="text-center">{{newstitle}}</h3>
                    <div class="text-center">
                        <span class="" style="margin-right:50px;"><i class="iconfont">&#xe9bd;</i> 仁迅科技</span> 
                        <span class=""><i class="iconfont">&#xe9bd;</i> {{newstime}}</span> 
                    </div>
                </div>
                <div class="news-content">
					<p>近日，仁迅科技成功获得世界卫生组织国际药物监测合作中心(WHO Collaborating Centre for International Drug Monitoring)的WHODrug Global Vendor认证,
                        这标志着我司已获得国际权威组织认可的药物编码服务商资质。截至目前为止,国内通过UMC WHODrug C3/B3格式认证的Vendor仅有7家,仁迅科技是国内第 8 家通过UMC授权的中国本土化科技公司。</p>
					<p>同时，<strong>仁迅科技的iTrial Genies®数智化临床研究平台</strong>也作为官方授权的专业药物编码（B3/C3格式）系统进入官方推荐列表。</p>
					<p> iTrial Genies EDC子系统和PVS药物警戒子系统均提供了在数据管理过程中的医学编码和药物编码功能。 </p>
					<div class="text-center"><img src="@/assets/img/news/news_5_1.png"></div>
                    <div class="text-center"><img src="@/assets/img/news/news_5_2.png"></div>
                    <h4 class="news-title-name">WHODrug简介</h4>
					<p>世界卫生组织药物词典（WHODrug）是业界公认较权威的药物编码字典，已被制药公司、临床研究机构和药物监管部门广泛使用。</p>
					<p>WHODrug在临床试验中用于合并用药的编码，在药品上市后监测中，则用于个例安全性报告中的药品名称编码，以加快信号检测。</p>
                    <p>美国FDA已要求申办方在提交至生物制品审评和研究中心的电子数据时采用WHODrug词典。</p>
                    <p>CDISC中的药品名称须采用WHODrug，SDTM中的药品分类变量（CMCLAS）需参照WHODrug中ATC第三层级（药理学亚组）。</p>
                    <p>日本药品及医疗器械管理局（pharmaceutical and medical devices agency，PMDA）要求从2003年3月开始申办方在提交电子数据集时，必须采用WHODrug对合并用药进行编码。</p>
                    <h4 class="news-title-name">WHODrug词典发展概况</h4>
                    <p>WHODrug起源于药品不良反应监测。</p>
                    <p>1968年WHO开始推行国际药品监测计划，旨在收集和交流药品不良反应报表；1970年在日内瓦成立WHO药物监测中心；</p>
                    <p>1978年该中心迁至瑞典乌普萨拉，1997年更名为UMC。</p>
                    <p>UMC作为WHO药物监测国际合作中心，是全球性药品不良反应监测机构。</p>
                    <p>UMC专门为中国建立了特有的编码词典WHODrug Global Chinese，订阅WHODrug Global的用户从2019年9月其可免费获得WHODrug Global Chinese。中文版与英文版采用相同的字典结构。</p>
                </div>
            </el-card>
        </div>
    </div>
</template>
<script>
import Inbanner from './pages/Inbanner'
export default{
    data() {
        return {
            newstitle: '仁迅科技成功获得UMC（Uppsala Monitoring Centre）官方认证',
            newstime: '2022.09.10',
        };
    },
    components:{
        Inbanner
    }
}
</script>
<style>
.text-left{
  text-align: left;
}
.text-center{
  text-align: center;
}
h2 {
    font-size: 22px;
    margin: 30px 0;
    font-weight: 700;
}
.news-title-name{
    text-align: center;
    font-size: 18px;
    color: #408bff;
}
.news-content img{
    max-width:100%;
}
.news-content p{
    text-indent:2em;
    font-size:14px;
    margin-bottom: 20px;
}
.news-content ol li{
    list-style: square;
    margin-left: 30px;
}
.news-content ol li p{
    text-indent:0em;
    
}
</style>